import numeral from "numeral";
import { cn } from "../../../utils/useFunctions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14
} from "../styles/pdf.style";

function ExpenseInsuranceDetailThreePDF({ page, data }) {
  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="ประกันของคุณ"
        icon="/images/insuranceClibboard.png"
        classNameIcon="w-[35px] h-[24px]"
        classNameTitle="text-[20px] font-bold"
      />

      <PdfCard
        className={"flex flex-col space-y-3"}
        title={"ประกันชีวิต"}
        classNameTitle={"text-[12px] font-[500]"}
      >
        <PdfCardWhite className={cn("px-3")}>
          <div className="flex flex-row w-full py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยโรยร้ายแรง (AIA CI Plus Gold) ไม่มีเงินคืน *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_aia_ci_plus_gold?numeral(
                data?.more_details?.compensation_aia_ci_plus_gold
              ).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยโรยร้ายแรง (AIA CI Plus) ไม่มีเงินคืน *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_aia_ci_plus?numeral(data?.more_details?.compensation_aia_ci_plus).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  บันทึก ซีไอท๊อปอัพ (แนบกับซีไอพลัส) *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_aia_ci_topup?numeral(data?.more_details?.compensation_aia_ci_topup).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยโรยร้ายแรง (Mutiple Care CI) ไม่มีเงินคืน *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_mutiple_care_ci?numeral(
                data?.more_details?.compensation_mutiple_care_ci
              ).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                ประกันภัยโรคร้ายแรงแบบซีไอรายปี *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.critical_illness_insurance_yearly_ci?numeral(
                data?.more_details?.critical_illness_insurance_yearly_ci
              ).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                ค่ารักษาพยาบาลเนื่องจากอุบัติเหตุ (PA)
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.medical_expenses_accident_pa?numeral(
                data?.more_details?.medical_expenses_accident_pa
              ).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                สถานะสิทธิประโยชน์ เช่น AIA Vitlaity
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.status_aia_vitlaity||'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  มูลค่าเวนคืนกรมธรรม์ /มูลค่าหน่วยลงทุน
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.policy_surrender_value?numeral(data?.more_details?.policy_surrender_value).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  เงินคืนตามสัญญาและเงินปันผลสะสมที่ฝากกับบริษัท
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.contractual_refund||'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ประเภทงวดชำระเบี้ย</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.type_of_payment||'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ค่าเบี้ยประกันครั้งล่าสุด</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.allowance_last_time?numeral(data?.more_details?.allowance_last_time).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ค่าเบี้ยประกันครั้งล่าสุด</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.allowance_last_time?numeral(data?.more_details?.allowance_last_time).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ค่าเบี้้ยประกันรวมรายปี</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.total_year?numeral(data?.more_details?.total_year).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">เลดีแคร์</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_lady_care?numeral(data?.more_details?.compensation_lady_care).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default ExpenseInsuranceDetailThreePDF;
